import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Button } from '@scio3/ui';
import { analyticsError } from '@/lib/analytics-service';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
    analyticsError({
      errorType: error.name,
      errorMessage: (error.message || '').slice(0, 200),
      page: window.location.pathname,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-muted">
          <div className="mx-4 max-w-md rounded-lg border bg-card p-8 text-center shadow-sm">
            <h1 className="text-xl font-semibold text-foreground">Something went wrong</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              An unexpected error occurred. Please reload the page.
            </p>
            <Button className="mt-6" onClick={() => window.location.reload()}>
              Reload Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
